import Box from "@material-ui/core/Box";
import MaterialTable from "material-table";
import React from "react";
import { Route, Switch, useHistory, withRouter } from "react-router-dom";
import { IP } from "../../../config/IP";
import OrderScreen from "../Order";

const MyOrder = () => {
	const tableRef = React.createRef();
	const history = useHistory();
	return (
		<Switch>
			Order
			<Route exact path={`/Shop/`}>
				<Box with="500">
					<MaterialTable
						with="200"
						title="My Order(s)"
						tableRef={tableRef}
						columns={[
							{ title: "Id", field: "_id" },

							{
								title: "totalCost",
								field: "totalCost",
								render: (rowData) =>
									rowData.currencyId +
									"" +
									Intl.NumberFormat().format(rowData.totalCost),
							},

							{ title: "status", field: "status" },
							{ title: "statusReason", field: "statusReason" },
							{ title: "transationDate", field: "transationDate" },
							{
								title: "Items",
								field: "items",
								render: (rowData) =>
									rowData.items.map((x) => x.style + " " + x.title).join("|"),
							},
						]}
						data={(query) =>
							new Promise((resolve, reject) => {
								let url = IP.nodeServer + "api/loadMyOrders";
								let inputs = { page: query.page + 1, limit: query.pageSize };

								fetch(url, {
									method: "POST",

									body: JSON.stringify(inputs),
									headers: {
										"Content-Type": "application/json",
									},
								})
									.then((response) => response.json())
									.then((result) => {
										console.log("MyOrders result=", result);
										resolve({
											data: result.docs,
											page: result.page - 1,
											totalCount: result.total,
										});
									});
							})
						}
						actions={[
							{
								icon: "refresh",
								tooltip: "Refresh Data",
								isFreeAction: true,
								onClick: () =>
									tableRef.current && tableRef.current.onQueryChange(),
							},
							{
								icon: "visibility",
								tooltip: "more Details",
								onClick: (event, rowData) => {
									console.log("rowData=", rowData);
									history.push({
										pathname: `/Shop/Order/${rowData._id}`,
									});
								},
							},
						]}
					/>
				</Box>
			</Route>
			<Route path={`/Shop/Order/:orderId`}>
				<OrderScreen />
			</Route>
		</Switch>
	);
};

export default withRouter(MyOrder);
